module.exports = __webpack_public_path__ + "public/img/junelight-Appstore-DE_original.0d6c339f.png";